import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled, css } from 'styled-components';
import { useResourceDocumentDataContextSafe } from '../../../context/resourceDataContext.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useQueryDocumentResourceFileContent } from '../../../../queries/useQueryDocumentResourceFileContent.js';
import { maxPlainTextLength } from '../../../../resource-details.config.js';
import { truncateText } from '@fabric-app/utils/text';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P } from '@fabric-app/ui/components/Typography';
import { Button } from '@fabric-app/ui/components/Button';
import Divider from '@fabric-app/ui/components/Divider';

const PlainText = styled.pre.withConfig({
  displayName: "ResourcePlainText__PlainText",
  componentId: "sc-344d83d2-0"
})([
  `color:`,
  `;white-space:pre-wrap;word-break:break-word;overflow-wrap:break-word;overflow:hidden;width:100%;`,
  `;`
], cssVar["color-text-primary"], ({ isTruncated }) => isTruncated && css([
  `position:relative;mask-image:linear-gradient( to bottom,`,
  ` 99.5%,transparent 100% );`
], cssVar["color-text-primary"]));
const ResourcePlainText = () => {
  const { resource, handleDownload } = useResourceDocumentDataContextSafe();
  const { data: plainTextContent } = useQueryDocumentResourceFileContent(resource, {
    select: (data) => {
      try {
        const decoder = new TextDecoder("utf-8");
        return decoder.decode(data);
      } catch (_e) {
        return null;
      }
    }
  });
  const truncatedContent = useMemo(() => {
    return plainTextContent ? truncateText(plainTextContent, maxPlainTextLength) : null;
  }, [
    plainTextContent
  ]);
  return /* @__PURE__ */ jsx(ScrollArea.Default, {
    "data-pan-id-ignore-resource-drag-resize": "xy",
    orientation: "vertical",
    asFlex: true,
    grow: true,
    expandVertically: true,
    children: /* @__PURE__ */ jsx(Flex, {
      style: {
        padding: "2rem"
      },
      minHeight: "100%",
      minWidth: "100%",
      gap: "sections",
      direction: "column",
      children: !plainTextContent ? /* @__PURE__ */ jsxs(Flex, {
        alignItems: "center",
        direction: "column",
        gap: "element",
        children: [
          /* @__PURE__ */ jsx(P, {
            size: "lg",
            children: "Failed to preview"
          }),
          /* @__PURE__ */ jsx(Button, {
            onClick: handleDownload,
            variant: "primary",
            size: "sm",
            children: "Download"
          })
        ]
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [
          /* @__PURE__ */ jsx(PlainText, {
            isTruncated: plainTextContent.length > maxPlainTextLength,
            children: truncatedContent
          }),
          plainTextContent.length > maxPlainTextLength && /* @__PURE__ */ jsxs(Fragment, {
            children: [
              /* @__PURE__ */ jsx(Divider, {}),
              /* @__PURE__ */ jsxs(Flex, {
                alignItems: "center",
                direction: "column",
                gap: "element",
                children: [
                  /* @__PURE__ */ jsx(P, {
                    size: "lg",
                    children: "Couldn&rquo;t preview the entire content"
                  }),
                  /* @__PURE__ */ jsx(Button, {
                    onClick: handleDownload,
                    variant: "primary",
                    size: "sm",
                    children: "Download"
                  })
                ]
              })
            ]
          })
        ]
      })
    })
  });
};

export { ResourcePlainText };
//# sourceMappingURL=ResourcePlainText.js.map
